{
  "version": 1,
  "asset_id": "ac965f06-ae41-41a8-94a9-a5a6ec21ad5b",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/ac965f06-ae41-41a8-94a9-a5a6ec21ad5b/ss01-card-p4.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/ac965f06-ae41-41a8-94a9-a5a6ec21ad5b/ss01-card-p4.webp",
  "original_filename": "ss01-card-p4.webp",
  "size": 166674,
  "content_type": "image/webp",
  "created_at": "2026-09-12T16:22:54Z"
}
